import Vue from 'vue';
import apiClient from '@/apiClient';

const state = {
  passwordUpdating: false,
  entryUrl: null,
  status: '',
  profile: {
    // id: '',
    // email: '',
    // name: '',
  },
  stats: {
    id: null,
    firstLoginWizardShow: false
  },
  orderStatuses: [],
  constructorNames: []
};

const getters = {
  getToken: state => state.token,
  getConstructorName: state => constructorId =>
    state.constructors.find(c => c.id === parseInt(constructorId, 10))
      ? state.constructors.find(c => c.id === parseInt(constructorId, 10)).name
      : null,

  getStatusName: state => statusId =>
    state.orderStatuses.find(s => s.id === statusId)
      ? state.orderStatuses.find(s => s.id === statusId).title
      : null,
  isAdmin: state => state.isAdmin
};

const actions = {
  userRequest: ({ commit, dispatch, state }) =>
    new Promise((resolve, reject) => {
      commit('userRequest');
      commit('startLoad');
      apiClient
        .get('/user')
        .then(resp => {
          commit(
            'userAdminState',
            resp.data.profile.isAdmin ? resp.data.profile.isAdmin : false
          );
          commit('userSuccess', resp.data.profile);
          commit('token', resp.data.token);
          commit('orderStatuses', resp.data.orderStatuses);
          // console.log(resp.data);
          commit('constructors', resp.data.constructors);
          commit('initialize');
          commit('endLoad');
          dispatch('ordersGet', state.profile.id);
          dispatch('clientsGet', state.profile.id);
          resolve(resp);
        })
        .catch(err => {
          console.error(err);
          commit('endLoad');
          commit('userError');
          // if resp is unauthorized, logout, to
          dispatch('logout');
          reject(err);
        });
    }),

  userStatsRequest: ({ commit }) =>
    new Promise((resolve, reject) => {
      apiClient
        .get('/user/stats')
        .then(resp => {
          commit('userStats', resp.data);
          commit('setTutorialCompleteStatus', resp.data.firstLoginWizardShow);
          resolve(resp);
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
    }),

  updatePassword: (_context, { currentPassword, newPassword }) =>
    new Promise((resolve, reject) => {
      apiClient
        .put('/user/password', {
          currentPassword,
          newPassword
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    })
};

const mutations = {
  setUserEntryUrl: (state, url) => {
    state.entryUrl = url;
  },

  userRequest: state => {
    state.status = 'loading';
  },

  userSuccess: (state, resp) => {
    state.status = 'success';
    Vue.set(state, 'profile', resp);
  },

  userStats: (state, resp) => {
    Vue.set(state, 'stats', resp);
  },

  orderStatuses: (state, resp) => {
    state.status = 'success';
    Vue.set(state, 'orderStatuses', resp);
  },
  token: (state, resp) => {
    Vue.set(state, 'token', resp);
  },
  constructors: (state, resp) => {
    state.status = 'success';
    Vue.set(state, 'constructors', resp);
  },
  userError: state => {
    state.status = 'error';
  },
  userAdminState: (state, flag) => {
    state.isAdmin = flag;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
